/**
 * Funkce pro omezení výběru hodnot ve dvou selecboxech navzájem
 *
 * Př. mám dva selectboxy OD DO, v každém můžu vybrtat hodnoty od 0 - 10
 * Pokud v prvním selectboxu vyberu hodnotu 5 v druhém se všechny hodnoty <= 5 označí jako disabled.
 * V druhém selectboxu je chování obdobné jen se označí jako disabled všechny hodnoty >= 5
 *
 * Propojení selectboxů probíhá přes data atributy "data-from-to-from" a "datafrom-to-to" v hodnotě těchto atributů je potřeba mít id "protějšího" selectboxu.
 */
export default function () {
	document
		.querySelectorAll('[data-from-to-from]')
		.forEach(function (minSelect) {
			minSelect.addEventListener('change', function (e) {
				let min = minSelect.value;
				let maxSelect = document.getElementById(
					minSelect.dataset.fromToFrom
				);
				if (maxSelect === null) {
					return;
				}

				let options = maxSelect.options;
				for (let i = 0; i < options.length; i++) {
					if (parseInt(options[i].value) < 0) {
						continue;
					}
					if (min > 0 && min >= parseInt(options[i].value)) {
						options[i].setAttribute('disabled', ''); // nastavení disabled pro option
						if (
							parseInt(maxSelect.value) ===
							parseInt(options[i].value)
						) {
							maxSelect.selectedIndex = 0;
							maxSelect.dispatchEvent(
								new Event('selectResetValue')
							);
						}
					} else {
						options[i].removeAttribute('disabled');
					}

					// event pro možnost reagovat na změnu atributu v jiné části kódu (např. MultiselectDropdown)
					options[i].dispatchEvent(
						new Event('optionChangedAttribute')
					);
				}
			});
		});

	document
		.querySelectorAll('[data-from-to-to]')
		.forEach(function (maxSelect) {
			maxSelect.addEventListener('change', function (e) {
				let max = maxSelect.value;
				let minSelect = document.getElementById(
					maxSelect.dataset.fromToTo
				);
				if (maxSelect === null) {
					return;
				}

				let options = minSelect.options;
				for (let i = 0; i < options.length; i++) {
					if (max > 0 && max <= parseInt(options[i].value)) {
						options[i].setAttribute('disabled', ''); // nastavení disabled pro option
						if (
							parseInt(minSelect.value) ===
							parseInt(options[i].value)
						) {
							minSelect.selectedIndex = 0;
							minSelect.dispatchEvent(
								new Event('selectResetValue')
							);
						}
					} else {
						options[i].removeAttribute('disabled');
					}

					// event pro možnost reagovat na změnu atributu v jiné části kódu (např. MultiselectDropdown)
					options[i].dispatchEvent(
						new Event('optionChangedAttribute')
					);
				}
			});
		});
}
